import { AppointmentPhase } from "components";
import LinkedShowsList from "components/LinkedShows/LinkedShowsList";
import { LargeClickableTitle } from "components/ListTemplate/LargeClickableTitle";
import { type ListTemplateLayout } from "components/ListTemplate/types";
import { ArtistSidePanel } from "components/SidePanel/Company/CompanySidePanel";
import { FormatArrivalTime } from "flights/lookup/FlightSearchResult";
import moment from "moment";
import { FlightSidePanel } from "components/SidePanel/Flight/FlightSidePanel";
import React from "react";
import { formatTime, formatWrittenDayMonthYear } from "utilities";

const FlightFromTo = ({ flight }: { flight: server.dto.FlightForList }) => {
  return <div className="flex-2 journey-card-grid">
    <div className="departs-from">
      <div className="info-text-regular margin-bottom-large">
        {formatWrittenDayMonthYear(flight.departureLocal)}
      </div>
      <div className="subtitle-text-regular margin-bottom-small">
        {flight.departureAirport.name} [{flight.departureAirport.iata || flight.departureAirport.icao || flight.departureAirport.faa}]
      </div>
      <div className="text-sublabel margin-bottom-small">
        {flight.departureAirport.location}
      </div>
    </div>
    <div className="departure-time nowrap info-text-regular">
      {formatTime(flight.departureLocal)}
    </div>
    <div className="arrow">
      <i className="icon-arrow-right small" />
    </div>
    <div className="arrives-at">
      <div className="info-text-regular margin-bottom-large">
        <FormatArrivalTime
          departure={moment.utc(flight.departureLocal)}
          arrival={moment.utc(flight.arrivalLocal)}
        />
      </div>
      <div className="subtitle-text-regular margin-bottom-small">
        {flight.arrivalAirport.name} [{flight.arrivalAirport.iata || flight.arrivalAirport.icao || flight.arrivalAirport.faa}]
      </div>
      <div className="text-sublabel margin-bottom-small">
        {flight.arrivalAirport.location}
      </div>
    </div>
  </div>;
};

export const getTitle = (item: server.dto.FlightForList) =>
  item.flightType === "commercial"
    ? `${RESX.Flight.resxFlight} ${item.flightDesignator}:`
    : `${RESX.Flight.PrivateJet}:`;

export const cardLayout = (): ListTemplateLayout<server.dto.FlightForList> => ({
  type: "card",
  sections: {
    renderTitle: item =>
      <FlightSidePanel
        flightId={item.flightId}
        trigger={<LargeClickableTitle
          icon={<AppointmentPhase value={item.phase} displayLabel={false} />}
          title={`${getTitle(item)} ${item.departureAirport?.iata || item.departureAirport?.icao || item.departureAirport?.faa} » ${item.arrivalAirport?.iata || item.arrivalAirport?.icao || item.arrivalAirport?.faa}`}
        />}
      />,
    hideTitle: () => false,
    renderBody: item => <>
      <FlightFromTo flight={item} />
      <LinkedShowsList shows={item.linkedShows} />
    </>,
    renderFooter: item => <div>
      <div className="margin-bottom-small">
        <ArtistSidePanel
          companyId={item.artist.artistId}
          trigger={<a>{item.artist.name}</a>}
        />
      </div>
      <div>
        {item.passengers.map((passanger, index) => <React.Fragment key={passanger.contactId}>
          <span className="s1_gray">{passanger.name.fullName}</span>
          {item.passengers.length - 1 !== index && <span className="s1_gray">, </span>}
        </React.Fragment>)}
      </div>
    </div>,
    hideFooter: item => !item.artist && item.passengers.length === 0
  }
});